var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "zixunContainer",
      staticClass: "zixun-container",
      class: _vm.bottomPadding
    },
    [
      _vm.isSkeleton
        ? _c(
            "div",
            { staticClass: "skeleton" },
            [
              _c("van-skeleton", { attrs: { title: "", row: 5 } }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "skeleton-group",
                attrs: { row: 3 }
              }),
              _vm._v(" "),
              _c("van-skeleton", { attrs: { row: 5 } }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "skeleton-group",
                attrs: { row: 3 }
              }),
              _vm._v(" "),
              _c("van-skeleton", { attrs: { row: 5 } }),
              _vm._v(" "),
              _c("van-skeleton", {
                staticClass: "skeleton-group",
                attrs: { row: 3 }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition-group",
        { attrs: { name: "zixun-container-detail", tag: "div" } },
        [
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isSkeleton,
                  expression: "!isSkeleton"
                }
              ],
              key: "zixun-detail"
            },
            [
              _c("div", { staticClass: "zixun-detail" }, [
                _c(
                  "p",
                  {
                    ref: "zixunDetailTitle",
                    staticClass: "zixun-detail-title"
                  },
                  [_vm._v(_vm._s(_vm.detail.Title))]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    ref: "zixunDetailParams",
                    staticClass: "zixun-detail-params flex"
                  },
                  [
                    _c("span", { staticClass: "zixun-detail-tag" }, [
                      _vm._v(_vm._s(_vm.detail.Info_Src))
                    ]),
                    _vm._v(" "),
                    _vm.isKaisaGlobalPcClient
                      ? _c(
                          "span",
                          {
                            staticClass: "zixun-detail-author",
                            attrs: { title: _vm.detail.Author }
                          },
                          [_vm._v(_vm._s(_vm.detail.Author))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "zixun-detail-time",
                        style: _vm.tag ? "margin-left: 10px;" : ""
                      },
                      [_vm._v(_vm._s(_vm.detail.Issue_date))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !!_vm.tag,
                        expression: "!!tag"
                      }
                    ],
                    ref: "zixunTag",
                    staticClass: "zixun-detail-note",
                    class: _vm.type === "2" ? "danger" : ""
                  },
                  [_vm._v(_vm._s(_vm.tag))]
                ),
                _vm._v(" "),
                !_vm.isSkeleton && _vm.stocks && _vm.stocks.length > 0
                  ? _c("div", { key: "stock", staticClass: "stocks" }, [
                      _c(
                        "div",
                        { staticClass: "stock-container" },
                        _vm._l(_vm.stocks, function(item) {
                          return _c(
                            "van-row",
                            {
                              key: item.secucode,
                              staticClass: "stock-item",
                              on: {
                                click: function($event) {
                                  return _vm.toStock($event, item.fullSecuCode)
                                }
                              }
                            },
                            [
                              _c(
                                "van-col",
                                {
                                  staticClass: "stock-name",
                                  attrs: { span: "13" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.secuAbbr || "--") +
                                      " " +
                                      _vm._s(
                                        item.fullSecuCode
                                          ? "[" +
                                              item.fullSecuCode.toUpperCase() +
                                              "]"
                                          : "--"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "van-col",
                                {
                                  class: _vm.computeClassName(item.changePct),
                                  attrs: { span: "6" }
                                },
                                [_vm._v(_vm._s(item.nowPrice || "--"))]
                              ),
                              _vm._v(" "),
                              _c(
                                "van-col",
                                {
                                  staticClass: "stock-change",
                                  class: _vm.computeClassName(item.changePct),
                                  attrs: { span: "5" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("decimalsToPercent")(
                                        item.changePct
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isSkeleton &&
                _vm.researchStock &&
                _vm.researchStock.length > 0
                  ? _c("div", { key: "stock", staticClass: "stocks" }, [
                      _c(
                        "div",
                        { staticClass: "stock-container" },
                        _vm._l(_vm.researchStock, function(item) {
                          return _c(
                            "van-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.stockName,
                                  expression: "item.stockName"
                                }
                              ],
                              key: item.stockCode,
                              staticClass: "stock-item",
                              on: {
                                click: function($event) {
                                  return _vm.toIndividualSharePage(item)
                                }
                              }
                            },
                            [
                              _c(
                                "van-col",
                                {
                                  staticClass: "stock-name",
                                  attrs: { span: "13" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.stockName || "--") +
                                      " " +
                                      _vm._s(
                                        item.stockCode
                                          ? "[" + item.stockCode + "]"
                                          : "--"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "van-col",
                                {
                                  staticClass: "text-align-right",
                                  class: _vm.computeClassName(item.changePct),
                                  attrs: { span: "6" }
                                },
                                [_vm._v(_vm._s(item.nowPrice || "--"))]
                              ),
                              _vm._v(" "),
                              _c(
                                "van-col",
                                {
                                  staticClass: "stock-change",
                                  class: _vm.computeClassName(item.changePct),
                                  attrs: { span: "5" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("decimalsToPercent")(
                                        item.changePct
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", {
                  ref: "zixunDetailWrap",
                  staticClass: "zixun-detail-content zixun-detail-wrap",
                  class: _vm.market === "A" || _vm.textNodeFlag ? "render" : "",
                  domProps: { innerHTML: _vm._s(_vm.detail.Contents) },
                  on: {
                    click: function($event) {
                      return _vm.previewImage($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.market !== "U" &&
                          _vm.detail.Url &&
                          _vm.detail.Url.length > 0 &&
                          _vm.type == "2",
                        expression:
                          "market!=='U' && detail.Url && detail.Url.length>0 && type == '2'"
                      }
                    ],
                    ref: "attach",
                    staticClass: "zixun-detail-content fujian",
                    on: {
                      click: function($event) {
                        return _vm.toDetail(_vm.detail.Url)
                      }
                    }
                  },
                  [_vm._v("\n          查看附件\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.market === "U" && _vm.type === "2",
                        expression: "market === 'U' && type === '2'"
                      }
                    ],
                    staticClass: "us-stock-notice"
                  },
                  [
                    _c("p", { staticClass: "us-notice-title" }, [
                      _vm._v(
                        "此公告共有" +
                          _vm._s(
                            _vm.detail.noticeList &&
                              _vm.detail.noticeList.length
                          ) +
                          "份独立文件："
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.detail.noticeList, function(notice) {
                      return _c(
                        "van-row",
                        { key: notice.name, staticClass: "notice-us" },
                        [
                          _c("van-col", { attrs: { span: "8" } }, [
                            _vm._v(_vm._s(notice.name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "van-col",
                            {
                              staticClass: "attach-us-notice",
                              attrs: { span: "8" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: notice.source },
                                  on: {
                                    click: function($event) {
                                      return _vm.toNotice($event, notice.source)
                                    }
                                  }
                                },
                                [_vm._v("查看公告原文")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "van-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: notice.translate,
                                  expression: "notice.translate"
                                }
                              ],
                              staticClass: "attach-us-notice",
                              attrs: { span: "8" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: notice.translate },
                                  on: {
                                    click: function($event) {
                                      return _vm.toNotice(
                                        $event,
                                        notice.translate
                                      )
                                    }
                                  }
                                },
                                [_vm._v("查看公告翻译")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "risk-hint" }, [
                      _vm._v(
                        "风险提醒：中文翻译由阿里云翻译提供支持，本平台对翻译信息的准确性或可靠性所造成的任何损失不承担任何责任。"
                      )
                    ])
                  ],
                  2
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isSkeleton,
                  expression: "!isSkeleton"
                }
              ],
              key: "share",
              ref: "share",
              staticClass: "share"
            },
            [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.detail.disclaimers ||
                      "免责声明：本文所有资料、数据等只供参考之用，不构成任何投资、交易策略的建议。本公司会竭力但不确保资料的准确和可靠,  亦不承担因任何不准确或遗漏而引起的损失或损害。"
                  )
                )
              ]),
              _vm._v(" "),
              _vm.isApp
                ? _c("share", {
                    attrs: { detail: _vm.detail, "style-mode": _vm.styleMode }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { key: "open-app" },
            [
              _c("open-app", {
                attrs: { "is-show": _vm.openAppIsShow, path: _vm.currentLink }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }